export class TabVo {
    id;
    filter;
}
